import { Pipe, PipeTransform } from '@angular/core';
import { AcdTypeEnum } from '../../samwebDescription/samwin/AcdTypeEnum';
import { isObservable, Observable, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { UserAcdExtensionInfoRemoteDto } from '../../../generated/signalR/user-acd-extension-info-remote-dto';
import { switchMap } from 'rxjs/operators';
import _ from 'lodash';

@Pipe({
   name: 'acdExtensionToAcdNumber$',
})
export class AcdExtensionToAcdNumberPipe implements PipeTransform {
   constructor(private translateService: TranslateService) {}

   transform(acdInfo: UserAcdExtensionInfoRemoteDto | Observable<UserAcdExtensionInfoRemoteDto>): Observable<string> {
      let acdInfo$: Observable<UserAcdExtensionInfoRemoteDto>;
      if (isObservable(acdInfo)) {
         acdInfo$ = acdInfo;
      } else {
         acdInfo$ = of(acdInfo);
      }

      return acdInfo$.pipe(
         switchMap((x) => {
            if (_.isNil(x)) {
               return of('');
            }

            if (AcdTypeEnum.getAcdTypeFromAcdLine(x.acdLine) === AcdTypeEnum.SOFTPHONE) {
               return this.translateService.get('samwin.softphone.device_number');
            }
            return of(x.acdNumber);
         })
      );
   }
}
